import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import notice from '../../../assets/icons/backOffice/Earnings/notice.svg';

import ulxIcon from '../../../assets/icons/backOffice/ULX.svg';
import uUSDTIcon from '../../../assets/icons/backOffice/uUSDT.svg';

import { InputBackOffice } from '../../../components/common/InputBackoffice';
import { ErrorToast } from '../../../components/common/Toasts/Toasts';
import { formatUSD } from '../../../helpers/helperFunctions';
import { P3 } from '../../../styles/FontStyles';
import { Button } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWithdrawWallet } from '../../../styles/Icons';
import {
  BankCard,
  FlexBetween,
  FlexCenter
} from '../../../styles/stylesStyled';
import { SmallTxt, Subtitle, Title } from './WithdrawStyled';
import { WithdrawSteps, WithdrawAvailability } from '../Portfolio.types';

interface WithdrawInitialProps {
  setStep: Dispatch<SetStateAction<WithdrawSteps>>;
  userWallets: any;
  amount: string;
  setAmount: Dispatch<SetStateAction<string>>;
  selected: any;
  availableBalance: number;
  withdrawAvailabilitySteps: number;
  availableUsdtToWithdraw: number;
}

export const WithdrawInitial = ({
  setStep,
  userWallets,
  amount,
  setAmount,
  selected,
  availableBalance,
  availableUsdtToWithdraw,
  withdrawAvailabilitySteps
}: WithdrawInitialProps) => {
  const { t } = useTranslation('earnings');

  const digit = /^(?=.*?[0-9])/;

  return (
    <div style={{ marginTop: '8vh' }}>
      <FlexCenter style={{ flexDirection: 'column' }}>
        <Title>
          {withdrawAvailabilitySteps === WithdrawAvailability.ULX
            ? 'wULX'
            : 'uUSDT'}{' '}
          {t('withdraw_part.initial.title')}
        </Title>

        <Subtitle style={{ textAlign: 'center' }}>
          {t('withdraw_part.initial.subtitleULX', {
            USDT:
              withdrawAvailabilitySteps === WithdrawAvailability.ULX
                ? 'wULX'
                : 'uUSDT'
          })}
        </Subtitle>
        <InputBackOffice
          placeholder={t(
            'withdraw_part.initial.witdhrawal_amount_placeholder',
            {
              MIN:
                withdrawAvailabilitySteps === WithdrawAvailability.ULX
                  ? '5'
                  : '3'
            }
          )}
          icon={
            withdrawAvailabilitySteps === WithdrawAvailability.ULX
              ? ulxIcon
              : uUSDTIcon
          }
          style={{ marginBottom: 8 }}
          onChange={(e: string) => {
            setAmount(e.replace(/[.,\s\D]/g, ''));
          }}
          pattern='[0-9]'
          value={amount}
        />
        <FlexBetween style={{ width: '100%', marginBottom: 12 }}>
          <SmallTxt>
            {t('withdraw_part.initial.balance')}:{' '}
            {formatUSD(
              withdrawAvailabilitySteps === WithdrawAvailability.ULX
                ? availableBalance
                : availableUsdtToWithdraw
            )}{' '}
            {withdrawAvailabilitySteps === WithdrawAvailability.ULX
              ? 'wULX'
              : 'uUSDT'}
          </SmallTxt>
          <SmallTxt>
            {withdrawAvailabilitySteps === WithdrawAvailability.ULX
              ? t('withdraw_part.initial.feeULX', {
                  wULX: 'wULX'
                })
              : `Fee: 3.5% or min 1 uUSDT`}
          </SmallTxt>
        </FlexBetween>
        <BankCard>
          <div>
            <div>
              {userWallets?.length > 0 ? (
                ''
              ) : (
                <div style={{ display: 'flex' }}>
                  <img src={notice} alt='card' />
                  {t('withdraw_part.initial.add_address_p1')}

                  <br />
                  {t('withdraw_part.initial.add_address_p2', {
                    USDT:
                      withdrawAvailabilitySteps === WithdrawAvailability.ULX
                        ? 'wULX'
                        : 'uUSDT'
                  })}
                </div>
              )}
            </div>
            <FlexCenter>
              {userWallets?.length > 0 && (
                <Icon mr='10' color={color.colors.neutral900}>
                  <IconWithdrawWallet />
                </Icon>
              )}

              <P3
                color={color.colors.neutral900}
                bold
                style={{ wordBreak: 'break-all' }}>
                {userWallets?.length > 0 && userWallets[selected]?.address}
              </P3>
            </FlexCenter>
          </div>
          <Button
            ml='10'
            w='auto'
            h='36px'
            onClick={() => {
              userWallets?.length > 0 ? setStep(4) : setStep(5);
            }}>
            <span>
              {userWallets?.length > 0
                ? t('withdraw_part.initial.change')
                : t('withdraw_part.initial.add')}
            </span>
          </Button>
        </BankCard>
        <Button
          maxWidth='200px'
          disabled={
            !amount || withdrawAvailabilitySteps === WithdrawAvailability.ULX
              ? Number(amount) < 5
              : Number(amount) < 3
          }
          onClick={() => {
            if (userWallets?.length === 0) {
              ErrorToast(t('withdraw_part.initial.err_address_required'));
            } else if (!amount.match(digit)) {
              ErrorToast(t('withdraw_part.initial.err_number_required'));
            } else if (
              withdrawAvailabilitySteps === WithdrawAvailability.ULX
                ? Number(amount) > availableBalance
                : Number(amount) > availableUsdtToWithdraw
            ) {
              ErrorToast(
                t('withdraw_part.initial.err_no_enough_usdt', {
                  wULX:
                    withdrawAvailabilitySteps === WithdrawAvailability.ULX
                      ? 'wULX'
                      : 'uUSDT'
                })
              );
            } else {
              setStep(2);
            }
          }}>
          {t('withdraw_part.initial.withdraw')}
        </Button>
      </FlexCenter>
    </div>
  );
};
